import { HasId } from '../interfaces';

export class Tenant implements HasId {
    public id: number;
    public name: string;
}


// WEBPACK FOOTER //
// ./src/models/Tenant.tsx